module.exports = __webpack_public_path__ + "static/b1000-5ed969a145dd06ad0476a1b4af9ad0f6.png";